import { useEffect, useState } from 'react'
import { get as localDbGet } from 'idb-keyval'
import useInterval from './useInterval'
import { sendSavedEventLogs } from 'helpers/userEventLogger'
import { PING_INTERVAL_MILLISECONDS, INSPECTIONS_ENV_URL } from 'config'

const useOnlineStatus = () => {
  const [isOnline, setIsOnline] = useState(false)
  const [showAsOnline, setShowAsOnline] = useState(false)
  const [pingInterval, setPingInterval] = useState(null) // interval in ms for the internet connection "ping". null stops the internet connection checks
  
  useEffect(() => {
    verifyInternetConnection() // run an initial online check at start
    
    setPingInterval(PING_INTERVAL_MILLISECONDS)
    
    return () => {
      setPingInterval(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    let temporaryOnlineTimer

    if (showAsOnline && !isOnline) {
      // DataStore has initiated a sync, but the online hook has not received a connected poll request yet
      // Engage a temporary online connection so the UI shows as online while sync occurs and allow online poll to catch up
      temporaryOnlineTimer = setTimeout(() => {
        setShowAsOnline(false)
        verifyInternetConnection()

        temporaryOnlineTimer = null
      }, PING_INTERVAL_MILLISECONDS)
    }

    return () => temporaryOnlineTimer && clearTimeout(temporaryOnlineTimer)
    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [showAsOnline])

  useEffect(() => {
    if (isOnline) {
      sendSavedEventLogs()
    }
  }, [isOnline])
  
  useInterval(() => verifyInternetConnection(), pingInterval)

  async function verifyInternetConnection() {
    // Fire a quick HEAD request to the host Inspections url to see if we get a response.
    const { env } = JSON.parse(await localDbGet('get-tenant-data'))

    const targetUrl = env ? INSPECTIONS_ENV_URL[env] : window.location.origin
    
    try {
      const response = await fetch(
        targetUrl,
        {
          method: 'HEAD',
          mode: 'no-cors'
        }
      )

      if (response) {
        // device is connected to the internet
        !isOnline && setIsOnline(true)
      }      
    } catch (err) {
      // device is not connected to the internet
      setIsOnline(false)
    }
  }

  function onDataStoreSync() {
    setShowAsOnline(true)
  }

  return {
    isOnline: isOnline || showAsOnline,
    onDataStoreSync
  }
}

export default useOnlineStatus
